import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TRANSLATION from 'components/twilio/translations';
import { DEFAULT_THEME_COLOR } from 'appenv';
import { useSelector } from 'react-redux';
import InsertInvitationIcon from 'components/icons/Calendar';
import EmailIcon from 'components/icons/EmailSmall';
import ChatroomIcon from 'components/icons/Chatroom';
import findAvailableLocale from 'models/helpers/findAvailableLocale';
import { selectLocale } from 'models/localization';
import { Paper } from '@material-ui/core';
import { COLORS } from '../../constants';

const ChatWindowPlaceHolderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: ${COLORS.GREY_M}
`;

const PlaceHolderPaper = styled(Paper)`
  min-width: 360px;
  text-align: center;
`;

const GreetingText = styled.h6`
  font-size: 16px;
  margin: 16px 0 0 0;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  height: 100px;
`;

const IconPaper = styled(Paper)`
  border-radius: 50%;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-basis: 120px;
  margin-left: 4px;
`;

const ICON_PAPER_WIDTH = 124;

const StyledEmailIcon = styled(EmailIcon)`
  flex-basis: calc(50% - ${ICON_PAPER_WIDTH / 2}px);
`;

const StyledInsertInvitationIcon = styled(InsertInvitationIcon)`
  margin-bottom: 5px;
  flex-basis: calc(50% - ${ICON_PAPER_WIDTH / 2}px);
`;

const StyledChatWindowPlaceHolderText = styled.div`
  padding-top: 32px;
  text-align: center;
  width: 50%;
`;

const ChatWindowPlaceholder: FC = () => {
  const { t } = useTranslation();
  const locale = useSelector(selectLocale);
  const { hall, themeColor = DEFAULT_THEME_COLOR } = useSelector((s) => s.eventConfigs);
  const greeting = findAvailableLocale(hall?.popOver?.boothGreeting, locale) || t('booth.greeting', 'Hi, feel free to talk to us!');

  return (
    <ChatWindowPlaceHolderContainer>
      <PlaceHolderPaper>
        <GreetingText>{greeting}</GreetingText>
        <IconContainer>
          <IconPaper elevation={6}>
            <ChatroomIcon width={58} height={48} color={themeColor} />
          </IconPaper>
          <StyledEmailIcon width={42.5} height={34} color={themeColor} />
          <StyledInsertInvitationIcon width={39.27} height={36} color={themeColor} />
        </IconContainer>
      </PlaceHolderPaper>
      <StyledChatWindowPlaceHolderText>
        {t(...TRANSLATION.COMMON.ONE_CLICK)}
      </StyledChatWindowPlaceHolderText>
    </ChatWindowPlaceHolderContainer>
  );
};

export default React.memo(ChatWindowPlaceholder);
